import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";

import ProjectGallery from "./pages/project-gallery-case-studies";
import ContactQuoteRequest from "./pages/contact-quote-request";
import HomepageWith3DConstructionExperience from "./pages/homepage-with-3d-construction-experience";
import ServicesOverview from "pages/services-overview";
import NationalCoverage from "pages/national-coverage";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Home de contacto en / */}
          <Route path="/" element={<HomepageWith3DConstructionExperience />} />

          {/* NUEVA RUTA CORTA */}
          <Route path="/homepage" element={<HomepageWith3DConstructionExperience />} />

          {/* REDIRECCIÓN DESDE LA RUTA LARGA (para LOCAL y PROD) */}
          <Route
            path="/homepage-with-3d-construction-experience"
            element={<Navigate to="/homepage" replace />}
          />

          <Route path="/project-gallery-case-studies" element={<ProjectGallery />} />
          <Route path="/services-overview" element={<ServicesOverview />} />
          <Route path="/national-coverage" element={<NationalCoverage />} />
          <Route path="/contact-quote-request" element={<ContactQuoteRequest />} />

          {/* Mantén el catch-all al final */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
